import {StateEnum} from '../enum';

export const NAME = StateEnum.coreAuth;

export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGOUT_LOADING = 'LOGOUT_LOADING';

export const UNAUTHORIZED_ROUTES: ReadonlyArray<string> = ['/register', '/activate', '/password-reset', '/login'];
